import React, { useState, useEffect } from "react";
import { useClientAuth } from "../../context/ClientAuthContext";
import { useNavigate } from "react-router-dom";
import Header from "../../components/appLayout/header";
import OrderService from "../../services/order";
import "./index.scss";

const orderService = new OrderService();

const OrdersPage = () => {
  const { currentClient } = useClientAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!currentClient) {
      navigate("/login-page");
      return;
    }
    loadOrders();
  }, [currentClient, navigate]);

  const loadOrders = async () => {
    setIsLoading(true);
    try {
      // Try to fetch real orders from API
      const response = await orderService.getUserOrders(currentClient.userId);
      setOrders(response.data || []);
    } catch (error) {
      console.error("Error loading orders:", error);
      
      // Fallback to mock data if API fails
      const mockOrders = [
        {
          _id: "1",
          orderNumber: "CMD-001",
          date: "2024-01-15",
          status: "Livré",
          total: 125.500,
          items: [
            {
              productId: "prod1",
              name: "Crème Anti-Âge",
              quantity: 2,
              price: 45.000,
              image: "https://via.placeholder.com/80x80"
            },
            {
              productId: "prod2", 
              name: "Sérum Vitamine C",
              quantity: 1,
              price: 35.500,
              image: "https://via.placeholder.com/80x80"
            }
          ]
        },
        {
          _id: "2",
          orderNumber: "CMD-002",
          date: "2024-01-10",
          status: "En cours",
          total: 89.000,
          items: [
            {
              productId: "prod3",
              name: "Masque Hydratant",
              quantity: 1,
              price: 89.000,
              image: "https://via.placeholder.com/80x80"
            }
          ]
        }
      ];
      setOrders(mockOrders);
    } finally {
      setIsLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "livré":
        return "#28a745";
      case "en cours":
        return "#ffc107";
      case "annulé":
        return "#dc3545";
      default:
        return "#6c757d";
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
  };

  if (!currentClient) {
    return (
      <div className="orders-page">
        <Header />
        <div className="orders-container">
          <div className="orders-error">
            <h2>Non connecté</h2>
            <p>Veuillez vous connecter pour voir vos commandes.</p>
            <button 
              className="btn-primary"
              onClick={() => navigate("/login-page")}>
              Se connecter
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="orders-page">
      <Header />
      <div className="orders-container">
        {/* Header */}
        <div className="orders-header">
          <h1>MES COMMANDES</h1>
          <div className="header-line"></div>
          <p className="orders-subtitle">
            Consultez l'historique de toutes vos commandes
          </p>
        </div>

        {/* Orders List */}
        <div className="orders-content">
          {isLoading ? (
            <div className="loading-state">
              <div className="spinner"></div>
              <p>Chargement de vos commandes...</p>
            </div>
          ) : orders.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">📦</div>
              <h3>Aucune commande trouvée</h3>
              <p>Vous n'avez pas encore passé de commande.</p>
              <button 
                className="btn-primary"
                onClick={() => navigate("/all-products")}>
                Découvrir nos produits
              </button>
            </div>
          ) : (
            <div className="orders-list">
              {orders.map((order) => (
                <div key={order._id} className="order-card">
                  <div className="order-header">
                    <div className="order-info">
                      <h3>Commande #{order.orderNumber}</h3>
                      <p className="order-date">{formatDate(order.date)}</p>
                    </div>
                    <div className="order-status">
                      <span 
                        className="status-badge"
                        style={{ backgroundColor: getStatusColor(order.status) }}>
                        {order.status}
                      </span>
                    </div>
                  </div>

                  <div className="order-items">
                    {order.items.map((item, index) => (
                      <div key={index} className="order-item">
                        <div className="item-image">
                          <img src={item.image} alt={item.name} />
                        </div>
                        <div className="item-details">
                          <h4>{item.name}</h4>
                          <p>Quantité: {item.quantity}</p>
                          <p className="item-price">{item.price.toFixed(3)} DT</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="order-footer">
                    <div className="order-total">
                      <span>Total: </span>
                      <strong>{order.total.toFixed(3)} DT</strong>
                    </div>
                    <div className="order-actions">
                      <button className="btn-secondary">Voir détails</button>
                      {order.status === "Livré" && (
                        <button className="btn-primary">Commander à nouveau</button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrdersPage;
